module.exports = __webpack_public_path__ + "static/media/cp4.d70d30c0.jpg";